import { render, staticRenderFns } from "./OrgSunsetWarningBanner.vue?vue&type=template&id=143be71a&scoped=true"
import script from "./OrgSunsetWarningBanner.vue?vue&type=script&lang=ts"
export * from "./OrgSunsetWarningBanner.vue?vue&type=script&lang=ts"
import style0 from "./OrgSunsetWarningBanner.vue?vue&type=style&index=0&id=143be71a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143be71a",
  null
  
)

/* custom blocks */
import block0 from "./OrgSunsetWarningBanner.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports